import { Button, Fab, Grid, Menu, MenuItem, MenuList, Paper, Tooltip } from '@material-ui/core'
import DatePicker from "Components/DatePicker"
import Input from 'Components/Input'
import PhoneInput from 'Components/PhoneInput'
import Select from 'Components/Select'
import Title from 'Components/Title'
import Wysiwyg from 'Components/Wysiwyg'
import ApiRequest from 'EurestoApi/ApiRequest'
import Bus from 'EurestoClass/Bus'
import Data from 'EurestoClass/Data'
import User from 'EurestoClass/User'
import DataComponent from 'EurestoComponents/DataComponents'
import Datagrid from 'EurestoComponents/Datagrid/index'
import EurestoDiv from 'EurestoComponents/EurestoDiv'
import MainForm from 'EurestoComponents/MainForm'
import ViewUpload from 'EurestoComponents/Upload/ViewUpload'
import project from 'EurestoConfig/project.config'
import Constants from 'EurestoFonction/Constants'
import Utils from 'EurestoFonction/Utils'
import moment from 'moment'
import React from 'react'
import { browserHistory } from 'react-router'
import SplitPane from 'react-split-pane'
import { WebSocketContact } from '../../../../../Utilitaire/Websocket/index'
import Media from '../../../Media/Page/Recherche'
import Reservations from '../../../Restaurant/Component/Demande'
import Sdd from '../../../SDD/Page/Dashboard/index'
import Coordonnees from '../Coordonnee'
import Divers from '../Divers/'
import EtablissementGroupe from '../EtablissementGroupe'
import Financiers from '../Financiers/Financiers'
import InformationTiers from '../InformationTiers'
import Options from '../Options/index2'
import Relation from '../Relation/'
import Relations from '../Relations/'
import './FicheContact.scss'

moment.locale('fr')

export default class FicheContact extends React.Component {
  generateState = (data, typeaction, typeentite, typC, typeRequest) => {
    let generateState = {}
    const entite = data.entite || typeentite
    const typeContact = data.type || typC

    if (entite === 1) {
      generateState = {
        anniversaire: data.anniversaire || {},
        marie: data.marie || {},
        numero_secu: data.numero_secu || '',
        lieu_naissance: data.lieu_naissance || '',
        plafond_encours: data.plafond_encours || undefined,
        vinistoria_id: data.vinistoria_id || undefined,
        nationalite_id: data.nationalite_id || undefined,
        langue_id: data.langue_id || undefined
      }
    } else {
      generateState = {
        siret: data.siret || '',
        code_naf_ape: data.code_naf_ape || '',
        tva_intra: data.tva_intra || '',
        iban: data.iban || '',
        rna: data.rna || '',
        rcs: data.rcs || '',
        bic: data.bic || '',
        designation_juridique: data.designation_juridique || ''
      }
    }
    if (typeContact === Constants.access.ETABLISSEMENT) {
      generateState = {
        ...generateState,
        google_analytics: data.google_analytics || '',
        email_identification: data.email_identification || '',
        glpi_id: data.glpi_id || undefined,
        code: data.code || '',
        region_tva_id: data.region_tva_id || undefined,
        licence_active: data.licence_active || 0,
        licence_date_archive: data.licence_date_archive || undefined,
        licence_date_blocage: data.licence_date_blocage || undefined,
        licence_date_activation: data.licence_date_activation || undefined,
        licence_type: data.licence_type || 1,
        blocage_temporaire: data.blocage_temporaire || 0,
      }
    }

    if (typeaction === 'update') {
      generateState = {
        ...generateState,
        id: data.id
      }
    }

    generateState = {
      key_action: Utils.getRandomNumber(),
      keyWysiwyg: Utils.getRandomNumber(),
      typeContact: typeContact,
      locked_by: data.locked_by,
      locked: typeaction === 'update'
        ? (data.locked === 1 && data.locked_by !== User.User.get().id)
        : false,
      disabled: !(typeaction === 'update' && data.locked === 1 && data.locked_by === User.User.get().id) && typeaction !== 'add',
      archive: data.archive_id,
      configuration: {
        langs: data.langs || [],
        modules: data.modules || [],
        mail: data.mail || [],
        sms: data.sms || [],
        serveurs: data.serveurs || [],
        interfaces: data.interfaces || [],
        activites: data.activites || []
      },
      contact: {
        sellsy_type: data.sellsy_type || undefined,
        sellsy_id: data.sellsy_id || undefined,
        action: typeaction,
        entite: entite,
        public: data.public || 0,
        type: data.type,
        media_id: data.media_id || '',
        media_lien: data.media_lien || '',
        confidentiel: data.confidentiel || 0,
        nom: data.nom || '',
        prenom: data.prenom || '',
        civilite_id: data.civilite_id || undefined,
        qualite_id: data.qualite_id || undefined,
        enseigne_id: data.enseigne_id || undefined,
        type_client_id: data.type_client_id || undefined,
        email: data.email || '',
        fixe: data.fixe || '',
        portable: data.portable || '',
        commentaire: data.commentaire || '',
        adresse1: data.adresse1 || '',
        adresse2: data.adresse2 || '',
        adresse3: data.adresse3 || '',
        cp: data.cp || '',
        ville: data.ville || '',
        exclusEmailing: data.exclusEmailing === undefined ? 1 : data.exclusEmailing,
        exclusSms: data.exclusSms === undefined ? 1 : data.exclusSms,
        exclusMailing: data.exclusMailing === undefined ? 1 : data.exclusMailing,
        adresses: data.adresses || [],
        telephones: data.coordonnees
          ? data.coordonnees.filter(c => c.type !== 1)
          : [],
        mails: data.coordonnees
          ? data.coordonnees.filter(c => c.type === 1)
          : [],
        relations: data.relations || [],
        information_tiers: data.information_tiers || {},
        pays_id: data.pays_id,
        vip: data.vip || 0,
        key_contact: data.key_contact || '',
        motif_id: data.motif_id,
        archive_id: data.archive_id,
        archive_commentaire: data.archive_commentaire || '',
        siteweb: data.siteweb || '',
        ...generateState
      }
    }
    return generateState
  }

  dlLicence = async (token) => {
    ApiRequest(project.api + 'configuration', {
      action: 'download',
      requete: 'licence'
    }, { token: token }).then(result => {
      if (result.code === 1) {
        const blob = new Blob([result.results], { type: "application/octet-stream" });
        const elem = document.getElementById('dl_licence_client')
        elem.style.display = 'unset'
        elem.download = "euresto_" + moment().format("YYYYMMDD") + ".lic"
        elem.href = window.URL.createObjectURL(blob);
      }
    })
  }

  constructor(props) {
    super(props)
    const g = this.generateState(props.data, props.typeaction, props.typeentite, props.typeContact || Constants.access.CLIENT, props.typeRequest)
    this.state = {
      action_option: 'view',
      date_information: {},
      key_date_information: Utils.getRandomNumber(),
      required: ((Data.get(Constants.module.CONFIGURATION, Constants.donnee.etablissement, { module: "restaurant" }) || {}).configuration || {}).formulaire_backoffice_contact_obligatoire,
      key_form: Utils.getRandomNumber(),
      keyFichiers: Utils.getRandomNumber(),
      UserTabSelected: this.props.UserTabSelected && parseInt(this.props.UserTabSelected) || 0,
      showFinanceGrid: true,
      showFinanceGridKey: Utils.getRandomNumber(),
      viewFichier: false,
      preSelectedDossier: this.props.dossier_id,
      preSelectedAction: this.props.action_id,
      preSelectedClasseur: this.props.classeur_id /*|| User.Info.get().classeur_id*/,
      ...g,
      contact_save: EurestoClone(g.contact)
    }
  }

  getRelationsGroupeEtablissementsClient = async () => {
    const result = await ApiRequest(project.api + 'crm', {
      action: 'get_relations',
      requete: 'client',
      id: this.state.contact.id
    }, { showAlertError: false })

    return {
      etablissements: result && result.relations || undefined
    }
  }

  getStatsEtablissement = async () => {
    const result = await ApiRequest(project.api + 'interface/sellsy', {
      action: 'get',
      requete: 'statistique',
      contact_id: this.state.contact.id
    }, { showAlertError: false })

    this.setState({
      stats: result && result.results || undefined
    })
  }
  getFichierContact = async () => {
    const result = await ApiRequest(project.api + 'commun', {
      action: 'list',
      requete: 'media',
      contact_id: this.state.contact.id
    }, { showAlertError: false })
    return result && result.results || []
  }

  getEtablissementsGroupe = async () => {
    const result = await ApiRequest(project.api + 'crm', {
      requete: 'groupe',
      action: 'etablissements',
      id: this.state.contact.id
    }, { showAlertError: false })
    return result && result.results.map(e => e.id) || []
  }

  handleOtherUpdateContact = (data) => {
    this.getInfoUpdateAdd()
    if ((!data.locked && !this.state.contact_update) || (data.locked && data.locked_by !== User.User.get().id)) {
      this.setState({
        contact_update: false,
        ...this.generateState(data, this.props.typeaction, data.entite || this.props.typeentite, data.type || this.props.typeContact || Constants.access.CLIENT, this.props.typeRequest),
        key_form: Utils.getRandomNumber()
      })
    } else {
      this.setState({
        contact_update: false
      })
    }
  }



  handleNewFichier = (data) => {
    let fichiers = this.state.fichiers

    if (data.action === Constants.broadcastAction.add) {
      fichiers.push(data.results)
      fichiers.move(fichiers.length - 1, 0)
    } else if (data.action === Constants.broadcastAction.update) {
      const pos = fichiers.findIndex(d => d.id === data.results.id)
      if (pos !== -1) {
        fichiers[pos] = data.results
      }
    } else if (data.action === Constants.broadcastAction.delete) {
      const pos = fichiers.findIndex(d => d && d.id === data.id)
      if (pos !== -1) {
        fichiers.splice(pos, 1)
      }
    }
    this.setState({ fichiers: fichiers, keyFichiers: Utils.getRandomNumber() })
  }

  getInfoUpdateAdd = () => {
    ApiRequest(project.api + 'crm', {
      requete: 'contact',
      action: 'information',
      id: this.state.contact.id
    }, { showAlertError: false }).then(result => {
      if (result && result.code === 1) {
        this.setState({
          key_date_information: Utils.getRandomNumber(),
          date_information: {
            ...result.results
          }
        })
      }
    })
  }

  getInfoLicence = () => {
    ApiRequest(project.api + 'crm', {
      requete: 'etablissement',
      action: 'licences',
      id: this.state.contact.id
    }, { showAlertError: false })
      .then(result => {
        if (result.code === 1) {
          this.setState({
            info_licence: result.results
          })
        }
      })
  }

  getInfoPoste = () => {
    ApiRequest(project.api + 'crm', {
      requete: 'etablissmeent',
      action: 'postes',
      contact_id: this.state.contact.id
    }, { showAlertError: false })
      .then(result => {
        if (result.code === 1) {
          this.setState({
            info_postes: result.results
          })
        }
      })
  }

  getLangues = () => {
    ApiRequest(project.api + 'configuration', {
      requete: 'langue',
      action: 'list',
      contact_id: this.state.contact.id
    }, { showAlertError: false })
      .then(result => {
        if (result.code === 1) {
          this.setState({
            langues: result.results
          })
        }
      })
  }

  getOptions = () => {
    ApiRequest(project.api + 'configuration', {
      requete: 'option',
      action: 'list',
      entite_id: this.state.contact.id
    }, { showAlertError: false })
      .then(result => {
        if (result.code === 1) {
          console.log(!(this.state.locked === false && this.state.disabled === false) && this.state.contact.action === 'update'
            && User.User.get().type === Constants.access.EURESTO
            && (this.state.typeContact === Constants.access.ETABLISSEMENT)
            && result.results.indexOf(Constants.options[Constants.methods.RESTAURANT].id) !== -1)
          if (!(this.state.locked === false && this.state.disabled === false) && this.state.contact.action === 'update'
            && User.User.get().type === Constants.access.EURESTO
            && (this.state.typeContact === Constants.access.ETABLISSEMENT)
            && result.results.indexOf(Constants.options[Constants.methods.RESTAURANT].id) !== -1) {
            const eir = document.getElementById("Euresto-Option-Restaurant")
            if (eir) {
              eir.setAttribute('href', `${project.api.replace(':5000', ':3001').replace('api', 'reservation')}?key=${this.state.contact.key_contact}`)
              eir.style.display = "block"
            }
          }
          this.setState({
            options: result.results
          })
        }
      })
  }

  async componentDidMount() {
    const newState = {}
    let { contact, contact_save } = this.state
    let fichiers = []
    if (this.state.contact.action === 'update') {
      this.getInfoUpdateAdd()
    }
    if (this.state.contact.action === 'update' && this.state.typeContact === Constants.access.ETABLISSEMENT) {
      this.getInfoLicence()
      //this.getInfoPoste()
      this.getLangues()
      this.getOptions()
      this.state.contact.sellsy_type === 'Client' && this.getStatsEtablissement()
    }
    if (!this.props.doNotLockUnlock) {
      if (Data.list(Constants.module.CONFIGURATION, Constants.donnee.etablissement).length > 0 && this.state.typeContact === Constants.access.CLIENT && (User.User.get().type === Constants.access.EURESTO || User.User.get().type === Constants.access.USER_GROUPE)) {
        const relations = await this.getRelationsGroupeEtablissementsClient()
        contact.etablissements = relations.etablissements
        contact_save = EurestoClone(contact)
        newState.contact = contact
        newState.contact_save = contact_save
      }

      if (this.state.typeContact === Constants.access.GROUPE) {
        contact.etablissements = await this.getEtablissementsGroupe()
        contact_save = EurestoClone(contact)
        newState.contact = contact
        newState.contact_save = contact_save
      }

      fichiers = !this.props.showInfo && await this.getFichierContact()
      if (this.state.contact.action === 'update') {
        WebSocketContact(false, this.state.contact.id)
      }

      if (!(this.state.locked === false && this.state.disabled === false) && sessionStorage.getItem('navigation') === 'true' && this.state.contact.action === 'update' && User.User.get().type === Constants.access.EURESTO && (this.state.typeContact === Constants.access.ETABLISSEMENT || this.state.typeContact === Constants.access.GROUPE)) {
        User.Connect.go(this.state.contact.key_contact).then(token => {
          const elem = document.getElementById('connect_to_client')
          elem.style.display = 'block'
          elem.setAttribute('href', '/?isConnectedAs=true&token=' + token)
          this.dlLicence(token)
          this.setState({
            contactToken: token
          })
        })
      }

      User.ContactIdRegisterCallBack.resetAllFichier()
      User.ContactIdRegisterCallBack.set({ get: this.handleOtherUpdateContact, fichier: this.handleNewFichier })
    }

    this.setState({
      fichiers: fichiers,
      ...newState
    }, this.props.forceUpdate && this.handleLockContact)
  }

  async componentWillUnmount() {
    User.ContactIdRegisterCallBack.resetAll()
    if (!this.props.doNotLockUnlock) {
      if (this.state.contact.action === 'update') {
        WebSocketContact(true, this.state.contact.id)
      }
      if (this.state.locked_by === User.User.get().id) {
        await this.handleCancelContact()
      }
    }

    const elem = document.getElementById('dl_licence_client')
    window.URL.revokeObjectURL(elem.href);
  }

  handleChange = (event, value) => {
    this.setState({ UserTabSelected: value })
  }

  cancelOptions = () => {
    this.setState({
      action_option: 'view'
    })
  }

  saveOptions = () => {
    if (this.state.action_option === 'view') {
      this.setState({
        action_option: 'update'
      })
    } else {
      Bus.$emit('save_options_contacts_' + this.state.contact.id, this.state.contact.id)
    }
  }

  render() {
    console.log(this.state.required, Data.get(Constants.module.CONFIGURATION, Constants.donnee.etablissement, { module: "restaurant" }))
    return <MainForm key={this.state.key_form + '_form_' + this.state.disabled}
      disabled={!this.state.disabled}
      {...(this.state.required && this.state.required.length ? {
      object: this.state.contact,
        required: this.state.required.reduce((requiredProps, requiredName) => ({
          ...requiredProps,
          [requiredName]: { message: `*** Vous devez renseigner le champ '${requiredName}'` }
        }), {})
      } : {})}
      mainTabProps={{
        style: {
          padding: '0 65px 0 35px'
        }
      }}
      isAllow={{
        delete: false && !this.props.showInfo && this.state.contact.type !== Constants.access.GROUPE && this.state.contact.type !== Constants.access.ETABLISSEMENT && (!this.state.locked || this.state.locked_by === User.User.get().id),
        update: !this.props.showInfo && !this.state.archive && this.state.UserTabSelected === 0 && (!this.state.locked || this.state.locked_by === User.User.get().id),
        add: !this.props.showInfo && this.state.contact.action === 'add',
        cancel: !this.props.doNotLockUnlock
      }}
      libelle={this.state.contact.nom + (this.state.contact.entite === 1 && (' ' + this.state.contact.prenom) || '')}
      action={(this.state.locked || this.state.disabled) && 'view' || this.state.contact.action}
      eurestoBodyStyle={{ padding: 0 }}
      style={{
        padding: 10,
        paddingTop: 0,
        top: ((this.state.locked || this.state.disabled) && 'view' || this.state.contact.action) === 'view' && this.state.UserTabSelected !== 0 && 19 || 0,
        position: 'relative'
      }}
      buttons={[
        {
          isAllow: User.TypeAccess.get(Constants.access.EURESTO) && this.state.contact.entite === 2 && this.state.typeContact === Constants.access.CLIENT && this.state.contact.action === 'update' &&
            !this.props.showInfo && !this.state.archive && this.state.UserTabSelected === 0 && (!this.state.locked || this.state.locked_by === User.User.get().id),
          title: 'Nouvel Établissement',
          className: 'EurestoSecondary--text',
          icon: ' ei-commun_modifier',
          cb: this.nouvelEtablissement
        },
        {
          isAllow: User.TypeAccess.get(Constants.access.EURESTO) && this.state.UserTabSelected === 5 && this.state.action_option === 'view',
          title: 'Modifier',
          className: 'EurestoSecondary--text',
          icon: ' ei-commun_modifier',
          cb: this.saveOptions
        },
        {
          isAllow: User.TypeAccess.get(Constants.access.EURESTO) && this.state.UserTabSelected === 5 && this.state.action_option === 'update',
          title: 'Enregistrer',
          className: 'EurestoSecondary--text',
          icon: ' ei-commun_modifier',
          cb: this.saveOptions
        },
        {
          isAllow: User.TypeAccess.get(Constants.access.EURESTO) && this.state.UserTabSelected === 5 && this.state.action_option === 'update',
          title: 'Annuler',
          className: 'EurestoError--text',
          icon: ' ei-commun_annuler',
          cb: this.cancelOptions
        },
      ]}
      onClickUpdate={!this.props.showInfo && !this.state.archive && this.state.UserTabSelected === 0 && ((!this.state.locked || this.state.locked_by === User.User.get().id) && this.state.disabled)}
      showTab={(!this.props.forceUpdate === false || this.state.contact.action !== 'add')}
      onSave={this.onSave}
      onUpdate={this.handleLockContact}
      onCancel={this.handleCancelContact}
      onDelete={this.handleDelete}
      onView={this.handleCancelContact}
      libelleAdd={EurestoI18n.t('commun:Nouveau contact')}
      modalHeight={this.props.modalHeight}
      handleSave={this.handleSave}
      handleChange={this.handleChange}
      value={this.state.UserTabSelected}
      tabs={[{
        value: 0,
        label: EurestoI18n.t('Informations'),
        component: this.TabInformation
      }, {
        value: 2,
        label: EurestoI18n.t('Activités'),
        component: this.TabDossier, //this.TabActivite //
      }, {
        value: 3,
        label: EurestoI18n.t('Fichiers'),
        component: this.TabFichier,
        allow: this.state.contact.action === 'update' && this.state.contactToken
      }, {
        value: 4,
        label: EurestoI18n.t('Factures'),
        component: this.TabFacture,
        allow: this.state.contact.action === 'update' && EurestoOption(Constants.options[Constants.methods.FACTURATION].id)
      }, {
        value: 5,
        label: EurestoI18n.t('Options'),
        component: this.TabOptions,
        allow: this.state.contact.action === 'update'
          && (this.state.typeContact === Constants.access.ETABLISSEMENT || this.state.typeContact === Constants.access.GROUPE)
      }, {
        value: 6,
        label: EurestoI18n.t('Réservations'),
        component: this.TabReservations,
        allow: EurestoOption(Constants.options[Constants.methods.RESTAURANT].id)
          && this.state.contact.action === 'update'
          && this.state.typeContact === Constants.access.CLIENT
        }, {
          value: 7,
          label: EurestoI18n.t('Divers'),
          component: this.TabDivers,
          allow: this.state.contact.action === 'update',
          backgroundColor: this.state.archive && EurestoColor('EurestoError'),
          color: this.state.archive && EurestoColor('EurestoText')
        }, {
          value: 8,
          label: EurestoI18n.t('Hébergé'),
          component: this.TabHeberge,
        allow: false && this.state.contact.action === 'update'
            && (this.state.typeContact === Constants.access.ETABLISSEMENT || this.state.typeContact === Constants.access.GROUPE),
          backgroundColor: this.state.archive && EurestoColor('EurestoError'),
          color: this.state.archive && EurestoColor('EurestoText')
        }]} general={this.FicheChildren}
    />
  }

  handleSave = () => {

  }

  handleContactStateChange = (data, name) => {
    if (name === 'nom' && this.state.contact.entite === 1 && data) {
      data = data.toUpperCase()
    }
    this.setState({
      contact: {
        ...this.state.contact,
        ...(name === 'picture' && {
          media_id: data.id,
          media_lien: data.media_lien
        } || {
          [name]: data,
        })
      }
    })
  }

  handleSubmitContact = async (action) => {
    const contact = EurestoClone(this.state.contact)
    contact.critereAutresEtablissements = []
    contact.information_tiers = this.state.contact.information_tiers
    contact.adresses = this.state.contact.adresses
    contact.coordonnees = [].concat(this.state.contact.mails).concat(this.state.contact.telephones)

    contact.dedupe = this.props.dedupe || []
    if (contact.dedupe.length > 0) {
      const i = contact.dedupe.findIndex(dc => dc === contact.id)
      if (i !== -1) {
        contact.dedupe.splice(i, 1)
      }
    }

    //contact.relations = contact.relations.filter(r => r.contact_id !== undefined && r.relation_id !== undefined)
    contact.action = action
    contact.requete = this.typeRequete()
    ApiRequest(project.api + 'crm', contact)
      .then(result => {
        if (result && result.code === 1) {
          result.libelle = this.state.contact.nom + (this.state.contact.entite === 1 && (' ' + this.state.contact.prenom) || '')
          try {
            WL && WL.Execute('ProcFromJS', JSON.stringify({
              ...this.state.contact,
              type: 'contact',
              action: this.state.contact.action,
              id: this.state.contact.id || result.id,
              date: result.date_modification
            }))
          } catch (err) {
          }
          if (this.props.handleSaveContact !== undefined) {
            this.props.handleSaveContact({
              ...contact,
              ...result
            })
          } else if (this.state.contact.action === 'add') {
            browserHistory.push({ pathname: '/crm/' + result.id })
          }
        } else {
          this.setState({
            locked: false,
            disabled: false,
            locked_by: User.User.get().id,
            key_form: Utils.getRandomNumber(),
          })
        }
      })
  }

  typeRequete = () => {
    if (this.state.typeContact === Constants.access.CLIENT) {
      return 'client'
    }
    if (this.state.typeContact === Constants.access.USER_GROUPE || this.state.typeContact === Constants.access.USER_ETS || this.state.typeContact === Constants.access.EURESTO) {
      return 'user'
    }
    if (this.state.typeContact === Constants.access.ETABLISSEMENT) {
      return 'etablissement'
    }
    if (this.state.typeContact === Constants.access.GROUPE) {
      return 'groupe'
    }
  }

  handleLockContact = async () => {
    if (!this.props.doNotLockUnlock) {
      const result = await ApiRequest(project.api + 'crm', {
        action: 'lock',
        requete: 'contact',
        id: this.state.contact.id
      }, { showAlertError: false })
      if (result && result.code === 1) {
        this.setState({
          locked: false,
          disabled: false,
          locked_by: User.User.get().id,
          //key_form: Utils.getRandomNumber()
        })
      } else {
        this.setState({
          locked: true,
          disabled: true,
          //key_form: Utils.getRandomNumber()
        }, () => alert('Une personne est déjà en cours de modification de cette fiche, vous ne pouvez la modifier'))
      }
    } else {
      this.setState({
        locked: false,
        disabled: false,
        //key_form: Utils.getRandomNumber()
      })
    }
  }

  handleExportToSellsy = type => {
    ApiRequest(project.api + 'interface', {
      requete: 'sellsy',
      action: 'set',
      type: type,
      id: this.state.contact.id
    }).then(result => {
      if (result.code === 1) {
        const contact = this.state.contact
        contact.sellsy_id = result.id
        const contact_save = EurestoClone(contact)
        this.setState({
          contact: contact,
          contact_save: contact_save
        })
      }
    })
  }

  handleCancelContact = async () => {
    if (this.state.contact.action === 'add') {
      try {
        WL && WL.Execute('ProcFromJS', JSON.stringify({
          type: 'contact',
          action: 'cancel',
          id: this.state.contact.id || undefined
        }))
      } catch (err) {
        if (!(this.props.handleCancelContact && this.props.handleCancelContact())) {
          browserHistory.push({ pathname: '/crm' })
        }
      }
    } else {
      this.setState({
        locked: false,
        disabled: true,
        contact: EurestoClone(this.state.contact_save),
        key_form: Utils.getRandomNumber(),
      }, () => {
        ApiRequest(project.api + 'crm', {
          action: 'unlock',
          requete: 'contact',
          id: this.state.contact.id
        }, { showAlertError: false })
          .then(result => {
            if (result && result.code === 1) {
              try {
                WL && WL.Execute('ProcFromJS', JSON.stringify({
                  type: 'contact',
                  action: 'cancel',
                  id: this.state.contact.id || undefined
                }))
              } catch (err) {
              }
            }
          })
      })
    }
  }

  FicheChildren = () => {
    return <Grid key={this.state.key_form} container justify={'flex-start'} alignContent={'flex-start'}
      alignItems={'stretch'}
      style={{
        margin: 0,
        padding: 7.5,
        paddingTop: 0,
        maxHeight: '100%',
        overflowY: 'auto',
        overflowX: 'hidden',
        textAlign: 'left'
      }}
      spacing={0}>
      <a href={''} target={'_blank'}
        id="connect_to_client"
        style={{
          padding: 5,
          display: 'none',
          borderRadius: 5,
          fontSize: 20,
          border: '1px solid ' + EurestoColor('EurestoPrimary')
        }}
        className={`EurestoText--text EurestoSecondary VisuFiche cursor-pointer ei-commun_connexion`} />
      <a target={'_blank'} style={{
        padding: 5,
        borderRadius: 5,
        display: 'none',
        fontSize: 20,
        border: '1px solid ' + EurestoColor('EurestoPrimary')
      }} id={"Euresto-Option-Restaurant"}
        href={"#"}
        className='EurestoText--text VisuLienResa cursor-pointer ei-reservation_calendrier_date EurestoSecondary' />
      {
        (User.TypeAccess.get(Constants.access.EURESTO)
          || User.TypeAccess.get(Constants.access.GROUPE))
        && (this.state.locked_by && this.state.locked_by !== User.User.get().id)
        &&
        <Tooltip disableTouchListener style={{}} interactive title={
          <div style={{ fontSize: 15, padding: 10 }}>
            <span className={'EurestoError--text'}>Bloquée le {(this.state.date_information.date_locked &&
              moment(this.state.date_information.date_locked).format('DD/MM/YY HH:mm:ss') || '')
              + (this.state.date_information.libelle_user_locked && (' par ' + this.state.date_information.libelle_user_locked) || '')}&nbsp;
            <i title="Cliquez ici pour débloquer" style={{ color: EurestoColor('EurestoPrimary') }}
                className={'ei-commun_cadena_ouvert cursor-pointer'}
                onClick={this.forceUnlock} /></span>
          </div>
        }>
          <i className={'VisuLockContact ei-commun_cadena_ferme cursor-pointer EurestoError--text'}
            style={{
              padding: '5px 6.5px',
              borderRadius: 5,
              fontSize: 20,
              border: '1px solid ' + EurestoColor('EurestoPrimary')
            }} />
        </Tooltip>
      }
      {
        <Tooltip disableTouchListener interactive placement="bottom-end" title={
          <Grid key={this.state.key_date_information} container
            style={{
              margin: 0,
              fontSize: 15,
              zIndex: 2,
              padding: 10,
              width: 350
            }} spacing={0}
            justify={'flex-start'}
            alignItems={'stretch'} alignContent={'flex-start'} direction={'column'}>
            {
              this.state.stats &&
              <React.Fragment>
                <b>Sur les 12 derniers mois : </b>
                <ul style={{ padding: "0 0 0 20px" }}>
                  <li
                    className={'EurestoPrimary--text'}
                    style={{ lineHeight: 1.3, padding: '2.5px 0' }}>
                    <b>{this.state.stats.chiffre_affaire.label} :</b> {this.state.stats.chiffre_affaire.value_label} ({this.state.stats.chiffre_affaire.unit})
                  </li>
                  <li
                    className={'EurestoPrimary--text'}
                    style={{ lineHeight: 1.3, padding: '2.5px 0' }}><b
                      style={{ color: EurestoColor('EurestoError') }}>{this.state.stats.factures_attentes.label} :</b> {this.state.stats.factures_attentes.value_label} ({this.state.stats.factures_attentes.unit})
                  </li>
                  <li
                    className={'EurestoPrimary--text'}
                    style={{ lineHeight: 1.3, padding: '2.5px 0' }}><b
                      style={{ color: 'orange' }}>{this.state.stats.devis_attentes.label} :</b> {this.state.stats.devis_attentes.value_label} ({this.state.stats.devis_attentes.unit})
                  </li>
                </ul>
              </React.Fragment>
            }


            <span className={'EurestoSecondary--text'}><i
              className={'ei-commun_ajouter'}
              style={{ lineHeight: 1.3 }} />{(this.state.date_information.date_creation &&
                moment(this.state.date_information.date_creation).format('DD/MM/YY HH:mm:ss') || '')
                + (this.state.date_information.libelle_user_creation && (' par ' + this.state.date_information.libelle_user_creation) || '')}</span>
            <span className={'EurestoPrimary--text'} style={{ lineHeight: 1.3 }}><i
              className={'ei-commun_modifier'} />{(this.state.date_information.date_modification &&
                moment(this.state.date_information.date_modification).format('DD/MM/YY HH:mm:ss') || '')
                + (this.state.date_information.libelle_user_modification && (' par ' + this.state.date_information.libelle_user_modification) || '')}</span>

          </Grid>}>
          <i style={{
            borderRadius: 5,
            fontSize: 20,
            padding: 5,
            border: '1px solid ' + EurestoColor('EurestoPrimary'),
            backgroundColor: this.state.stats && this.state.stats.factures_attentes.value && EurestoColor('EurestoError')
              || this.state.stats && this.state.stats.devis_attentes.value && 'orange'
              || EurestoColor('EurestoSecondary')
          }}
            className={'EurestoText--text VisuInfo cursor-pointer ei-commun_question'} />
        </Tooltip>
      }

      <Grid item xs={12} style={{
        margin: 0,
        padding: 0,
        paddingTop: 5,
        position: 'relative'
      }}>
        <Grid container style={{
          margin: 0,
          padding: 0,
          paddingBottom: 10,
          width: '100%'
        }} spacing={0} justify={'space-between'} alignItems={'center'} alignContent={'center'} wrap={'nowrap'}>
          <Grid item style={{
            margin: 0,
            padding: 0
          }}>
            <Paper style={{
              background: 'transparent',
              height: 100
            }}>
              <Grid container style={{
                margin: 0,
                padding: 7.5
              }} spacing={0} justify={'space-between'} alignItems={'center'} alignContent={'center'} wrap={'nowrap'}>
                <Grid item style={{
                  margin: 0,
                  padding: 0
                }}>
                  <Grid container style={{
                    margin: 0,
                    padding: 2.5,
                    height: 85,
                    position: 'relative'
                  }} spacing={0} direction={'column'} wrap={'nowrap'} justify={'space-around'} alignContent={'center'}
                    alignItems={'center'}>
                    <Grid item style={{
                      margin: 0,
                      padding: 0,
                      height: '50%',
                      position: 'relative'
                    }}>
                      <Grid container style={{
                        margin: 0,
                        padding: 0,
                        height: '100%'
                      }} spacing={0} direction={'column'} justify={'center'} alignItems={'center'}
                        alignContent={'center'} wrap={'nowrap'}>
                        <Tooltip disableTouchListener
                          title={<div style={{
                            fontSize: 15,
                            padding: 10
                          }}>{this.state.contact.entite === 2 && 'Entité' || 'Personne'}</div>}>
                          <i className={(!this.state.disabled && 'cursor-pointer' || '') + ' fa-2x fa ' + (
                            this.state.contact.entite === 2 && 'ei-crm_morale EurestoPrimary--text' || 'ei-crm_physique EurestoSecondary--text')}
                            onClick={() => !this.state.disabled && this.handleContactStateChange(this.state.contact.entite === 1 && 2 || 1, 'entite')} />
                        </Tooltip>
                      </Grid>
                    </Grid>
                    <Grid item style={{
                      margin: 0,
                      padding: 0,
                      height: '50%',
                      position: 'relative'
                    }}>
                      <Grid container style={{
                        margin: 0,
                        padding: 0,
                        height: '100%'
                      }} spacing={0} direction={'column'} justify={'center'} alignItems={'center'}
                        alignContent={'center'} wrap={'nowrap'}>
                        <Tooltip disableTouchListener
                          title={<div style={{ fontSize: 15, padding: 10 }}>VIP</div>}>
                          <DataComponent onChange={this.handleContactStateChange} name='vip'
                            inline
                            disabled={this.state.disabled} data={this.state.contact.vip}
                            contact={this.state.contact} type={Constants.typeSaisie.Stars} />
                        </Tooltip>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>

                {
                  this.state.typeContact === Constants.access.CLIENT && !User.TypeAccess.get(Constants.access.EURESTO) &&
                  <Grid item style={{
                    margin: 0,
                    padding: 0,
                  }}>
                    <Grid container style={{
                      margin: 0,
                      padding: 2.5,
                      height: 85,
                    }} spacing={0} direction={'column'} wrap={'nowrap'} justify={'space-around'}
                      alignContent={'center'} alignItems={'center'}>
                      <Grid item style={{
                        margin: 0,
                        padding: 0,
                        height: '50%',
                        position: 'relative'
                      }}>
                        <Grid container style={{
                          margin: 0,
                          padding: 0,
                          height: '100%'
                        }} spacing={0} direction={'column'} justify={'center'} alignItems={'center'}
                          alignContent={'center'} wrap={'nowrap'}>
                          <Tooltip disableTouchListener
                            title={<div style={{
                              fontSize: 15,
                              padding: 10
                            }}>{this.state.contact.confidentiel && 'Fiche confidentielle' || 'Fiche non confidentielle'}</div>}>
                            <i
                              className={(!this.state.disabled && 'cursor-pointer' || '') + ' fa-2x ei-crm_confidentiel ' + (
                                this.state.contact.confidentiel && 'EurestoSecondary--text' || 'disabled')}
                              onClick={() => !this.state.disabled && this.handleContactStateChange(!this.state.contact.confidentiel, 'confidentiel')} />
                          </Tooltip>
                        </Grid>
                      </Grid>

                      <Grid item style={{
                        margin: 0,
                        padding: 0,
                        height: '50%',
                        position: 'relative'
                      }}>
                        <Grid container style={{
                          margin: 0,
                          padding: 0,
                          height: '100%'
                        }} spacing={0} direction={'column'} justify={'center'} alignItems={'center'}
                          alignContent={'center'} wrap={'nowrap'}>

                          <Tooltip disableTouchListener
                            title={<div style={{
                              fontSize: 15,
                              padding: 10
                            }}>{this.state.contact.public && 'Fiche public' || 'Fiche privée'}</div>}>
                            <i
                              className={(!this.state.disabled && 'cursor-pointer' || '') + ' fa-2x ei-crm_public ' + (
                                this.state.contact.public && 'EurestoSecondary--text' || 'disabled')}
                              onClick={() => !this.state.disabled && this.handleContactStateChange(!this.state.contact.public, 'public')} />
                          </Tooltip>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                }
              </Grid>
            </Paper>
          </Grid>
          <Grid item style={{
            margin: 0,
            padding: 0,
            maxWidth: 128,
            maxHeight: 100,
            position: 'relative',
            background: 'transparent',
          }}>
            <Paper style={{
              background: 'transparent'
            }}>
              {
                (this.state.locked || this.state.disabled) && 'view' && this.state.contact.siteweb &&
                <a style={{ position: 'absolute', width: '100%', height: '100%' }} href={this.state.contact.siteweb}
                  target={'blank'} />
              }
              <DataComponent onChange={this.handleContactStateChange} name='picture'
                avatarStyle={{
                  borderRadius: 10,
                  maxWidth: 100,
                  maxHeight: 100
                }} style={{
                  height: 100
                }} disabled={this.state.disabled} data={{
                  id: this.state.contact.media_id,
                  lien: this.state.contact.media_lien
                }} type={Constants.typeSaisie.Picture}
                defineData object={{
                  picture: {
                    id: this.state.contact.media_id,
                    lien: this.state.contact.media_lien
                  },
                  type: this.state.contact.entite === 1 && 'contact' || 'entite',
                  entite: this.state.contact.entite,
                  id: this.state.contact.id,
                  code: this.state.contact.code
                }} />
            </Paper>
          </Grid>
          <Grid item style={{
            margin: 0,
            padding: 0
          }}>
            <Paper style={{
              background: 'transparent',
              height: 100
            }}>
              <Grid item style={{
                margin: 0,
                padding: 7.5,
              }}>
                <Grid container style={{
                  margin: 0,
                  padding: 2.5,
                  height: 85,
                  position: 'relative'
                }} spacing={0} direction={'column'} wrap={'nowrap'} justify={'space-around'}
                  alignContent={'center'} alignItems={'center'}>
                  <Grid item style={{
                    margin: 0,
                    padding: 0,
                    height: '50%',
                    position: 'relative'
                  }}>
                    <Grid container style={{
                      margin: 0,
                      padding: 0,
                      height: '100%'
                    }} spacing={0} direction={'column'} justify={'center'} alignItems={'center'}
                      alignContent={'center'} wrap={'nowrap'}>
                      {/*<Tooltip disableTouchListener
                  title={this.state.contact.exclusMailing && 'Exclus campagne postale' || 'Inclus campagne postale'}>
                  <i className={(!this.state.disabled && 'cursor-pointer' || '') + ' fa-2x fa fa-send ' + (
                    this.state.contact.exclusMailing && 'EurestoError--text' || 'EurestoSecondary--text')}
                     onClick={() => !this.state.disabled && this.handleContactStateChange(!this.state.contact.exclusMailing, 'exclusMailing')}/>
                </Tooltip>*/}
                      <Tooltip disableTouchListener
                        title={<div style={{
                          fontSize: 15,
                          padding: 10
                        }}>{this.state.contact.exclusEmailing && 'Exclus campagne email' || 'Inclus campagne email'}</div>}>
                        {
                          this.state.contact.exclusEmailing &&
                          <i style={{ fontSize: 30, position: 'relative', zIndex: 2 }}
                            className={'ei-commun_bloquer EurestoError--text'}
                            onClick={() => !this.state.disabled && this.handleContactStateChange(!this.state.contact.exclusEmailing, 'exclusEmailing')}>
                            <i style={{ fontSize: 30, position: 'absolute', top: 0, left: 0, zIndex: -1 }}
                              className={(!this.state.disabled && 'cursor-pointer' || '') + ' fa-2x ei-commun_notification_email EurestoSecondary--text'}
                            />
                          </i> || <i style={{ fontSize: 30 }}
                            className={(!this.state.disabled && 'cursor-pointer' || '') + ' fa-2x ei-commun_notification_email EurestoSecondary--text'}
                            onClick={() => !this.state.disabled && this.handleContactStateChange(!this.state.contact.exclusEmailing, 'exclusEmailing')} />
                        }
                      </Tooltip>
                    </Grid>
                  </Grid>
                  <Grid item style={{
                    margin: 0,
                    padding: 0,
                    height: '50%',
                    position: 'relative'
                  }}>
                    <Grid container style={{
                      margin: 0,
                      padding: 0,
                      height: '100%'
                    }} spacing={0} direction={'column'} justify={'center'} alignItems={'center'}
                      alignContent={'center'} wrap={'nowrap'}>
                      <Tooltip disableTouchListener
                        title={<div style={{
                          fontSize: 15,
                          padding: 10
                        }}>{this.state.contact.exclusSms && 'Exclus campagne sms' || 'Inclus campagne sms'}</div>}>
                        {
                          this.state.contact.exclusSms &&
                          <i style={{ fontSize: 30, position: 'relative', zIndex: 2 }}
                            className={'ei-commun_bloquer EurestoError--text'}
                            onClick={() => !this.state.disabled && this.handleContactStateChange(!this.state.contact.exclusSms, 'exclusSms')}>
                            <i style={{ fontSize: 30, position: 'absolute', top: 0, left: 0, zIndex: -1 }}
                              className={(!this.state.disabled && 'cursor-pointer' || '') + ' fa-2x ei-commun_notification_sms EurestoSecondary--text'}
                            />
                          </i> || <i style={{ fontSize: 30 }}
                            className={(!this.state.disabled && 'cursor-pointer' || '') + ' fa-2x ei-commun_notification_sms EurestoSecondary--text'}
                            onClick={() => !this.state.disabled && this.handleContactStateChange(!this.state.contact.exclusSms, 'exclusSms')} />
                        }
                      </Tooltip>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </Grid>
      {[32820, 2, 1036, 8, 291536].includes(User.User.get().id) &&
        (this.state.contact.entite === 2)
        &&
        <Title inline title={'Sellsy'}>
          <Grid container spacing={0} className={'EurestoPrimary--text anchorElementSellsy'}
            aria-owns={this.state.anchorSellsyActionEl ? 'action-menu-sellsy' : null}
            aria-haspopup="true"
            onClick={(event) => {
              if (!this.props.showInfo && this.state.UserTabSelected === 0
                && (!this.state.locked || this.state.locked_by === User.User.get().id)) this.handleClickElSellsyAction(event)
            }}
            style={{ borderRadius: 5, margin: 0, padding: 0, cursor: this.state.UserTabSelected === 0 && 'pointer' }}>
            {this.state.contact.sellsy_id === undefined
              &&
              [32820, 2, 291536].includes(User.User.get().id) && <Button style={{ marginBottom: 5 }}
                className={'EurestoPrimary EurestoText--text'} variant="contained"
                size="small" fullWidth>Exporter vers Sellsy</Button>
              ||
              this.state.contact.sellsy_id && <Grid container spacing={0} style={{ margin: 0, padding: 0 }}>
                <Grid item xs style={{ margin: 0, padding: 0 }}>
                  <Input disabled={true} type='text' value={this.state.contact.sellsy_id} />
                </Grid>
                <Grid item style={{ margin: 0, padding: 0, display: !this.state.contact.sellsy_id && 'none' }}
                  className={'anchorCloseElementSellsy'}>
                  <Grid container spacing={0} style={{ margin: 0, padding: 5, height: '90%', width: '100%' }}
                    justify={'center'} alignItems={'center'} alignContent={'center'}>
                    <a className={'ei-crm_public'} target="_blank" rel="noopener noreferrer"
                      href={`https://www.sellsy.com/?_f=third&thirdid=${this.state.contact.sellsy_id}`} />
                  </Grid>
                </Grid>
              </Grid>}
            {[2, 32820].includes(User.User.get().id) && <Menu
              style={{ paddingRight: 5, paddingLeft: 5 }}
              id={'action-menu-sellsy'}
              keepMounted
              anchorEl={this.state.anchorSellsyActionEl || null}
              open={Boolean(this.state.anchorSellsyActionEl) || false}
              onClose={this.handleCloseElSellsyAction}>
              <MenuList>
                <MenuItem
                  style={{
                    backgroundColor: this.state.contact.sellsy_type === 'Client' && EurestoColor('EurestoPrimary'),
                    color: this.state.contact.sellsy_type === 'Client' && EurestoColor('EurestoText'),
                    padding: 5,
                    cursor: this.state.contact.sellsy_type !== 'Client' && 'cursor' || 'not-alowed',
                  }}
                  onClick={() => {
                    if (this.state.contact.sellsy_type !== 'Client') {
                      this.handleExportToSellsy('Client')
                    }
                  }}>
                  {`Export${this.state.contact.sellsy_type === 'Client' && 'é' || 'er'} comme Client`}
                </MenuItem>
                <MenuItem
                  style={{
                    backgroundColor: this.state.contact.sellsy_type === 'Supplier' && EurestoColor('EurestoPrimary'),
                    color: this.state.contact.sellsy_type === 'Supplier' && EurestoColor('EurestoText'),
                    padding: 5,
                    cursor: this.state.contact.sellsy_type !== 'Supplier' && 'cursor' || 'not-alowed',
                  }}
                  onClick={() => {
                    if (this.state.contact.sellsy_type !== 'Supplier') {
                      this.handleExportToSellsy('Supplier')
                    }
                  }}>
                  {`Export${this.state.contact.sellsy_type === 'Supplier' && 'é' || 'er'} comme Fournisseur`}
                </MenuItem>
                <MenuItem
                  style={{
                    backgroundColor: this.state.contact.sellsy_type === 'Prospects' && EurestoColor('EurestoPrimary'),
                    color: this.state.contact.sellsy_type === 'Prospects' && EurestoColor('EurestoText'),
                    padding: 5,
                    cursor: this.state.contact.sellsy_type !== 'Prospects' && 'cursor' || 'not-alowed',
                  }}
                  onClick={() => {
                    if (this.state.contact.sellsy_type !== 'Prospects') {
                      this.handleExportToSellsy('Prospects')
                    }
                  }}>
                  {`Export${this.state.contact.sellsy_type === 'Prospects' && 'é' || 'er'} comme Prospect`}
                </MenuItem>
              </MenuList>
            </Menu>}
          </Grid>
        </Title>}
      <DataComponent title={EurestoI18n.t('crm:Qualité')} name='qualite_id'
        disabled={this.state.disabled} type={Constants.typeSaisie.ComboSimple}
        onChange={this.handleContactStateChange} inline data={this.state.contact.qualite_id}
        object={Constants.donnee.qualite} module={Constants.module.CRM}
        search={this.state.contact.entite !== undefined
          ? {
            type: {
              contains: [this.state.contact.entite, this.state.typeContact]
            },
            actif: {
              in: [1, User.TypeAccess.get(Constants.access.EURESTO) && 2 || 3]
            }
          }
          : {
            actif: {
              in: [1, User.TypeAccess.get(Constants.access.EURESTO) && 2 || 3]
            }
          }} />
      <DataComponent title={EurestoI18n.t('crm:Type')} name='type_client_id'
        disabled={this.state.disabled} type={Constants.typeSaisie.ComboSimple}
        onChange={this.handleContactStateChange} inline data={this.state.contact.type_client_id}
        object={Constants.donnee.type_client} module={Constants.module.CRM}
        search={this.state.contact.entite !== undefined
          ? {
            type: {
              contains: this.state.contact.entite
            },
            actif: {
              in: [1, User.TypeAccess.get(Constants.access.EURESTO) && 2 || 3]
            }
          }
          : {
            actif: {
              in: [1, User.TypeAccess.get(Constants.access.EURESTO) && 2 || 3]
            }
          }} /> {
        this.state.contact.entite === 1 &&
        <DataComponent title={EurestoI18n.t('crm:Civilité')} name='civilite_id'
          disabled={this.state.disabled} type={Constants.typeSaisie.ComboSimple}
          onChange={this.handleContactStateChange} inline data={this.state.contact.civilite_id}
          object={Constants.donnee.civilite} module={Constants.module.COMMUN}
          search={this.state.contact.entite !== undefined
            ? {
              type: this.state.contact.entite,
              actif: {
                in: [1, User.TypeAccess.get(Constants.access.EURESTO) && 2 || 3]
              }
            }
            : {
              actif: {
                in: [1, User.TypeAccess.get(Constants.access.EURESTO) && 2 || 3]
              }
            }} />
      }

      <Input
        onChange={(data, name) => this.handleContactStateChange(data && this.state.contact.entite === 1 && data.toUpperCase() || data, name)}
        name='nom' inline disabled={this.state.disabled} type='text'
        rowsMax={this.state.contact.entite !== 1 && 3}
        InputProps={{ style: { fontWeight: 'bold' } }}
        multi={this.state.contact.entite !== 1}
        className='upText' value={this.state.contact.nom}
        title={EurestoI18n.t('crm:Nom')} />
      {this.state.contact.entite === 1 &&
        <Input onChange={this.handleContactStateChange} name='prenom' inline disabled={this.state.disabled} type='text'
          InputProps={{ style: { fontWeight: 'bold' } }}
          value={this.state.contact.prenom} title={EurestoI18n.t('crm:Prénom')} />}
      {User.VinistoriaCRM.get() &&
        <Input onChange={this.handleContactStateChange} name='vinistoria_id' inline disabled={this.state.disabled}
          type='text' value={this.state.contact.vinistoria_id} title={EurestoI18n.t('crm:ID Vinistoria')} />}
      {this.state.typeContact === Constants.access.ETABLISSEMENT &&
        <Input onChange={this.handleContactStateChange} name='code' type='text' inline className='upText'
          value={this.state.contact.code} disabled={this.state.contact.action === 'update'}
          title={EurestoI18n.t('crm:Code')} />}
      <Input onChange={this.handleContactStateChange} name='email' inline disabled={this.state.disabled} type='text'
        value={this.state.contact.email}
        title={EurestoI18n.t('crm:E-mail')} /> {this.state.typeContact === Constants.access.ETABLISSEMENT && User.TypeAccess.get(Constants.access.EURESTO) &&
          <Input onChange={this.handleContactStateChange} name='email_identification' inline disabled={this.state.disabled}
            type='text' value={this.state.contact.email_identification} title={EurestoI18n.t('crm:@API')} />}
      <PhoneInput onChange={this.handleContactStateChange} name='fixe' inline disabled={this.state.disabled}
        defaultRegionCode={this.state.contact.pays_id && Data.get(Constants.module.COMMUN, Constants.donnee.pays, { id: this.state.contact.pays_id }).code_alpha2.toUpperCase()}
        value={this.state.contact.fixe} title={EurestoI18n.t('crm:Fixe')} />
      <PhoneInput onChange={this.handleContactStateChange} name='portable' inline disabled={this.state.disabled}
        defaultRegionCode={this.state.contact.pays_id && Data.get(Constants.module.COMMUN, Constants.donnee.pays, { id: this.state.contact.pays_id }).code_alpha2.toUpperCase()}
        value={this.state.contact.portable} title={EurestoI18n.t('crm:Portable')} />
      <Input title={EurestoI18n.t('crm:Adresse')} name={'adresse1'} inline disabled={this.state.disabled}
        onChange={this.handleContactStateChange} value={this.state.contact.adresse1} />
      <Input name={'adresse2'} inline disabled={this.state.disabled} onChange={this.handleContactStateChange}
        value={this.state.contact.adresse2} />
      <Input name={'adresse3'} inline disabled={this.state.disabled} onChange={this.handleContactStateChange}
        value={this.state.contact.adresse3} />
      <Input title={EurestoI18n.t('crm:CP')} inline name={'cp'} disabled={this.state.disabled}
        onChange={this.handleContactStateChange} value={this.state.contact.cp} />
      <Input title={EurestoI18n.t('crm:Ville')} inline name={'ville'} disabled={this.state.disabled}
        onChange={this.handleContactStateChange} value={this.state.contact.ville} />

      <DataComponent onChange={this.handleContactStateChange} name='pays_id' inline
        disabled={this.state.disabled} data={this.state.contact.pays_id} object={'pays'}
        type={Constants.typeSaisie.PaysNationaliteLangue}
        defineData />
      {this.state.contact.entite === 1 &&
        <DataComponent onChange={this.handleContactStateChange} inline
          name='nationalite_id' disabled={this.state.disabled} data={this.state.contact.nationalite_id}
          object={'nationalite'} type={Constants.typeSaisie.PaysNationaliteLangue} defineData />}
      {this.state.contact.entite === 1 &&
        <DataComponent onChange={this.handleContactStateChange} inline
          name='langue_id' disabled={this.state.disabled} data={this.state.contact.langue_id}
          type={Constants.typeSaisie.PaysNationaliteLangue} defineData />}
      {this.state.typeContact === Constants.access.ETABLISSEMENT &&

        <Grid container style={{ margin: 0, padding: 0 }} spacing={0} justify={'center'} alignItems={'center'}>
          <Grid item xs style={{ margin: 0, padding: 0 }}><Select title={EurestoI18n.t('crm:Licence')}
            name="licence_active"
            inline
            disabled={this.state.disabled}
            onChange={this.handleContactStateChange}
            value={this.state.contact.licence_active}
            options={[{
              value: 1,
              label: EurestoI18n.t('crm:Active')
            }, {
              value: 0,
              label: EurestoI18n.t('crm:Archivée'),
              style: {
                backgroundColor: EurestoColor('EurestoError'),
                color: EurestoColor('EurestoText')
              }
            }, {
              label: EurestoI18n.t('crm:Bloquée'),
              value: -1,
              style: {
                backgroundColor: EurestoColor('disabled', ''),
                color: EurestoColor('EurestoText')
              }
            }]} />
          </Grid>
          <Grid item style={{ margin: 0, padding: "5px 0px 5px 5px" }}>
            <a href={'/'} target={'_blank'}
              id="dl_licence_client"
              style={{
                padding: 5,
                display: 'none',
                borderRadius: 5,
                fontSize: 12,
                border: '1px solid ' + EurestoColor('EurestoPrimary')
              }}
              className={`EurestoText--text EurestoSecondary cursor-pointer ei-commun_download`} />
          </Grid>
        </Grid>
      }
      {this.state.typeContact === Constants.access.ETABLISSEMENT && this.state.contact.licence_active === 1 &&
        <DatePicker title={EurestoI18n.t('crm:Date Activation')}
          name="licence_date_activation"
          inline
          disabled={this.state.disabled}
          onChange={this.handleContactStateChange}
          value={this.state.contact.licence_date_activation} />
      }
      {(this.state.typeContact === Constants.access.ETABLISSEMENT && this.state.contact.licence_active === -1 ||
        this.state.typeContact === Constants.access.ETABLISSEMENT && this.state.contact.licence_active === 1) &&
        <DatePicker title={EurestoI18n.t('crm:Date Blocage')}
          name="licence_date_blocage"
          inline
          disabled={this.state.disabled}
          onChange={this.handleContactStateChange}
          value={this.state.contact.licence_date_blocage} />
      }
      {this.state.typeContact === Constants.access.ETABLISSEMENT && this.state.contact.licence_active === 0 &&
        <DatePicker title={EurestoI18n.t('crm:Date archive')}
          name="licence_date_archive"
          inline
          disabled={this.state.disabled}
          onChange={this.handleContactStateChange}
          value={this.state.contact.licence_date_archive} />
      }
      {this.state.typeContact === Constants.access.ETABLISSEMENT &&
        <Select title={EurestoI18n.t('crm:Type licence')}
          name="licence_type"
          inline
          disabled={this.state.disabled}
          onChange={this.handleContactStateChange}
          value={this.state.contact.licence_type}
          options={[{
            value: 1,
            label: 'Annuel'
          }, {
            value: 2,
            label: 'Semestriel'
          }, {
            value: 3,
            label: 'Trimestriel'
          }, {
            value: 4,
            label: 'Mensuel'
          }]} />
      }
      {this.state.typeContact === Constants.access.ETABLISSEMENT &&
        <Select title={EurestoI18n.t('crm:Blocage temporaire')}
          name="blocage_temporaire"
          inline
          disabled={this.state.disabled}
          onChange={this.handleContactStateChange}
          value={this.state.contact.blocage_temporaire}
          options={[{
            value: 0,
            label: 'Non'
          }, {
            value: 1,
            label: 'Oui'
          }]} />
      }
      <div style={{ height: 40, width: '100%' }} />
    </Grid>
  }

  handleCloseElSellsyAction = _ => {
    this.setState({
      anchorSellsyActionEl: null
    })
  }

  handleClickElSellsyAction = (event) => {
    if (event && (event.target.className.indexOf('anchorElementSellsy') !== -1 || Utils.findparentClass(event.target.parentNode, 'anchorElementSellsy'))
      && (event.target.className.indexOf('anchorCloseElementSellsy') === -1 && !Utils.findparentClass(event.target.parentNode, 'anchorCloseElementSellsy'))) {
      this.setState({
        anchorSellsyActionEl: event.target
      })
    }
  }

  forceUnlock = async (e) => {
    e.preventDefault()
    e.stopPropagation()
    await ApiRequest(project.api + 'crm', {
      action: 'force_unlock',
      requete: 'contact',
      id: this.state.contact.id
    }, { showAlertError: false })
  }

  onSave = (action) => {
    this.setState({
      locked: false,
      disabled: true,
      key_form: Utils.getRandomNumber(),
      contact_update: true
    }, () => this.handleSubmitContact(action))
  }

  handleDelete = async () => {
  }

  nouvelEtablissement = () => {
    this.setState({
      typeContact: Constants.access.ETABLISSEMENT
    }, this.handleLockContact)
  }

  onChangeRelations = (data) => {
    this.handleContactStateChange(data, 'relations')
  }

  TabInformation = () => {
    let relations = (this.state.contact.relations || [])
    const coordonnees = [
      ...(this.state.contact.mails || []),
      ...(this.state.contact.telephones || []),
      ...(this.state.contact.adresses || [])
    ]
    return (<div style={{ position: 'relative' }}>
      <Relation maxHeight={'100%'}
        sellsy={Boolean(this.state.contact.sellsy_id)}
        clientName={this.state.contact.nom + (this.state.contact.entite === 1 && (' ' + this.state.contact.prenom) || '')}
        type={'relations_clients'} disabled={this.state.disabled} onChange={this.onChangeRelations}
        data={relations} />

      <Coordonnees onChange={this.handleContactStateChange}
        disabled={this.state.disabled} data={coordonnees} />

      <InformationTiers contact={this.state.contact}
        typeContact={this.state.typeContact}
        disabled={this.state.disabled}
        onChange={this.handleContactInformationsTiersChange} />

      {
        ((Data.list(Constants.module.CONFIGURATION, Constants.donnee.etablissement).length > 0
          && this.state.typeContact === Constants.access.CLIENT &&
          (User.User.get().type === Constants.access.EURESTO || User.User.get().type === Constants.access.USER_GROUPE))
          || (this.state.typeContact === Constants.access.GROUPE && User.TypeAccess.get(Constants.access.EURESTO))) &&
        <EurestoDiv id={'onglet_contact_etablissement_relations'} key={this.state.key_form + '_etablissements'}
          title='Établissements' expandable expanded>
          {
            (Data.list(Constants.module.CONFIGURATION, Constants.donnee.etablissement).length > 0 && this.state.typeContact === Constants.access.CLIENT && (User.User.get().type === Constants.access.EURESTO || User.User.get().type === Constants.access.USER_GROUPE)) &&
            <Relations type={Constants.dataType.etablissement} defineData
              onChange={this.onChangeRelationsClientEtablissementsGroupe}
              data={this.state.contact.etablissements !== undefined
                ? this.state.contact.etablissements
                : []} />
          }
          {
            (this.state.typeContact === Constants.access.GROUPE && User.TypeAccess.get(Constants.access.EURESTO)) &&
            <EtablissementGroupe
              disabled={this.state.disabled}
              onChange={this.onChangeEtablissementsGroupe}
              data={this.state.contact.etablissements} />
          }
        </EurestoDiv>
      }

      <EurestoDiv id={'onglet_contact_autres_informations'} key={this.state.key_form + '_autre_info'}
        title='Autres Informations' expandable expanded>
        <SplitPane split={'horizontal'} minSize={300} defaultSize={300} style={{ position: 'relative' }}>
          <Grid container style={{
            margin: 0,
            padding: 0,
            height: '100%',
          }} spacing={0}>
            <Grid item style={{
              margin: 0,
              padding: 5,
              height: '100%',
              position: 'relative',
            }} sm={12} md={6}>
              <Wysiwyg
                key={this.state.keyWysiwyg}
                onChange={this.handleContactStateChange}
                maxHeight={'100%'}
                name='commentaire'
                disabled={this.state.disabled}
                value={this.state.contact.commentaire} />
            </Grid>
            {
              this.state.contact.entite === 1 && <Grid item style={{
                margin: 0,
                padding: 5
              }} sm={12} md={6}>
                <Grid container style={{
                  margin: 0,
                  padding: 0
                }} spacing={0}>
                  <Grid container style={{
                    margin: 0,
                    padding: 0,
                    height: '100%'
                  }} spacing={0} direction={'row'} alignItems={'center'} justify={'center'}>
                    <Grid item style={{
                      margin: 0,
                      padding: '0 10px'
                    }} xs={12} md={6}>
                      <DataComponent name='marie' title={EurestoI18n.t('crm:Date de mariage')}
                        disabled={this.state.disabled}
                        inline
                        type={Constants.typeSaisie.Date} onChange={this.handleContactStateChange}
                        data={this.state.contact.marie} defineData />
                    </Grid>
                    <Grid item style={{
                      margin: 0,
                      padding: '0 10px'
                    }} xs={12} md={6}>
                      <DataComponent name='anniversaire' title={EurestoI18n.t('crm:Date d\'anniversaire')}
                        disabled={this.state.disabled} type={Constants.typeSaisie.Date}
                        inline
                        onChange={this.handleContactStateChange}
                        data={this.state.contact.anniversaire} defineData />
                    </Grid>
                  </Grid>
                  <Grid container style={{
                    margin: 0,
                    padding: 0
                  }} spacing={0}>
                    <Grid item style={{
                      margin: 0,
                      padding: '0 10px'
                    }} xs={12} md={6} xl={4}>
                      <Input onChange={this.handleContactStateChange} name='numero_secu' disabled={this.state.disabled}
                        type='text' value={this.state.contact.numero_secu} title={EurestoI18n.t('crm:N° sécu')} />
                    </Grid>
                    <Grid item style={{
                      margin: 0,
                      padding: '0 10px'
                    }} xs={12} md={6} xl={4}>
                      <Input onChange={this.handleContactStateChange} name='lieu_naissance'
                        disabled={this.state.disabled}
                        type='text' value={this.state.contact.lieu_naissance}
                        title={EurestoI18n.t('crm:◊Naissance')} />
                    </Grid>
                    <Grid item style={{
                      margin: 0,
                      padding: '0 10px'
                    }} xs={12} md={6} xl={4}>
                      <Input onChange={this.handleContactStateChange} name='plafond_encours'
                        disabled={this.state.disabled} type='number' value={this.state.contact.plafond_encours}
                        title={EurestoI18n.t('crm:Encours')} />
                    </Grid>
                    <Grid item style={{
                      margin: 0,
                      padding: '0 10px'
                    }} xs={12} md={6} xl={4}>

                      <Grid container spacing={0} style={{ margin: 0, padding: 0 }} justify={'center'}
                        alignItems={'center'} alignContent={'center'}>
                        <Grid item xs style={{ margin: 0, padding: 0 }}>
                          <Input onChange={this.handleContactStateChange} name='siteweb' disabled={this.state.disabled}
                            type='text' value={this.state.contact.siteweb} title={EurestoI18n.t('crm:Site web')} />
                        </Grid>
                        <Grid item style={{
                          margin: 0,
                          padding: 10,
                          paddingTop: 15,
                          display: !this.state.contact.siteweb && 'none'
                        }}>
                          <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '90%', width: '100%' }}
                            justify={'center'} alignItems={'center'} alignContent={'center'}>
                            <a className={'ei-crm_public'} target="_blank" rel="noopener noreferrer"
                              href={this.state.contact.siteweb} />
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              ||
              <Grid item style={{
                margin: 0,
                padding: 5
              }} sm={12} md={6}>
                <Grid container style={{
                  margin: 0,
                  padding: 0
                }} spacing={0}>
                  <Grid item style={{
                    margin: 0,
                    padding: '0 10px'
                  }} xs={12} md={6} xl={4}>
                    <DataComponent name='civilite_id' title={EurestoI18n.t('crm:Forme Juridique')}
                      disabled={this.state.disabled}
                      columnOptions={'abrege'}
                      type={Constants.typeSaisie.ComboSimple} onChange={this.handleContactStateChange}
                      data={this.state.contact.civilite_id}
                      object={Constants.donnee.civilite} module={Constants.module.COMMUN}
                      search={this.state.contact.entite !== undefined
                        ? {
                          type: this.state.contact.entite
                        }
                        : {}} />
                  </Grid>
                  <Grid item style={{
                    margin: 0,
                    padding: '0 10px'
                  }} xs={12} md={6} xl={4}>
                    <Input onChange={this.handleContactStateChange} name='designation_juridique'
                      disabled={this.state.disabled} type='text' value={this.state.contact.designation_juridique}
                      title={EurestoI18n.t('crm:Raison sociale')} />
                  </Grid>
                  <Grid item style={{
                    margin: 0,
                    padding: '0 10px'
                  }} xs={12} md={6} xl={4}>
                    <Input onChange={this.handleContactStateChange} name='rna' disabled={this.state.disabled}
                      type='text'
                      value={this.state.contact.rna} title={EurestoI18n.t('crm:RNA')} />
                  </Grid>
                  <Grid item style={{
                    margin: 0,
                    padding: '0 10px'
                  }} xs={12} md={6} xl={4}>
                    <Input onChange={this.handleContactStateChange} name='rcs' disabled={this.state.disabled}
                      type='text'
                      value={this.state.contact.rcs} title={EurestoI18n.t('crm:RCS')} />
                  </Grid>
                  <Grid item style={{
                    margin: 0,
                    padding: '0 10px'
                  }} xs={12} md={6} xl={4}>
                    <Input onChange={this.handleContactStateChange} name='siret' disabled={this.state.disabled}
                      type='text' value={this.state.contact.siret} title={EurestoI18n.t('crm:Siret')} />
                  </Grid>
                  <Grid item style={{
                    margin: 0,
                    padding: '0 10px'
                  }} xs={12} md={6} xl={4}>
                    <Input onChange={this.handleContactStateChange} name='code_naf_ape' disabled={this.state.disabled}
                      type='text' value={this.state.contact.code_naf_ape}
                      title={EurestoI18n.t('crm:Code NAF/APE')} />
                  </Grid>
                  <Grid item style={{
                    margin: 0,
                    padding: '0 10px'
                  }} xs={12} md={6} xl={4}>
                    <Input onChange={this.handleContactStateChange} name='tva_intra' disabled={this.state.disabled}
                      type='text' value={this.state.contact.tva_intra} title={EurestoI18n.t('crm:Tva intra')} />
                  </Grid>
                  <Grid item style={{
                    margin: 0,
                    padding: '0 10px'
                  }} xs={12} md={6} xl={4}>
                    <Input onChange={this.handleContactStateChange} name='iban' disabled={this.state.disabled}
                      type='text'
                      value={this.state.contact.iban} title={EurestoI18n.t('crm:IBAN')} />
                  </Grid>
                  <Grid item style={{
                    margin: 0,
                    padding: '0 10px'
                  }} xs={12} md={6} xl={4}>
                    <Input onChange={this.handleContactStateChange} name='bic' disabled={this.state.disabled}
                      type='text'
                      value={this.state.contact.bic} title={EurestoI18n.t('crm:BIC')} />
                  </Grid>
                  <Grid item style={{
                    margin: 0,
                    padding: '0 10px'
                  }} xs={12} md={6} xl={4}><Grid container spacing={0} style={{ margin: 0, padding: 0 }}>
                      <Grid item xs style={{ margin: 0, padding: 0 }}>
                        <Input onChange={this.handleContactStateChange} name='siteweb' disabled={this.state.disabled}
                          type='text' value={this.state.contact.siteweb} title={EurestoI18n.t('crm:Site web')} />
                      </Grid>
                      <Grid item style={{
                        margin: 0,
                        padding: 10,
                        paddingTop: 15,
                        display: !this.state.contact.siteweb && 'none'
                      }}>
                        <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '90%', width: '100%' }}
                          justify={'center'} alignItems={'center'} alignContent={'center'}>
                          <a className={'ei-crm_public'} target="_blank" rel="noopener noreferrer"
                            href={this.state.contact.siteweb} />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  {
                    this.state.typeContact === Constants.access.ETABLISSEMENT && <Grid item style={{
                      margin: 0,
                      padding: '0 10px'
                    }} xs={12} md={6} xl={4}>
                      <DataComponent name='region_tva_id' disabled={this.state.disabled}
                        title={EurestoI18n.t('crm:Région')}
                        type={Constants.typeSaisie.ComboSimple} onChange={this.handleContactStateChange}
                        data={this.state.contact.region_tva_id}
                        object={Constants.donnee.region_tva} module={Constants.module.GESTION} />
                    </Grid>
                  }
                  {this.state.typeContact === Constants.access.ETABLISSEMENT && <Grid item style={{
                    margin: 0,
                    padding: '0 10px'
                  }} xs={12} md={6} xl={4}>
                    <Input onChange={this.handleContactStateChange} name='google_analytics'
                      disabled={this.state.disabled}
                      type='text' value={this.state.contact.google_analytics}
                      title={EurestoI18n.t('crm:Google Analytics')} />
                  </Grid>}
                </Grid>
              </Grid>
            }
            {/*<Grid item style={{
            margin: -5,
            padding: 0
          }} xs={12}>
            <i className={'btn fa fa-' + (
              !this.state.all_commentaire && 'chevron-down' || 'chevron-up')} onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()
              this.setState({
                all_commentaire: !this.state.all_commentaire
              })
            }}/>
          </Grid>*/}
          </Grid>
        </SplitPane>
      </EurestoDiv>

      {

        this.state.contact.action === 'update' && this.state.typeContact === Constants.access.ETABLISSEMENT && this.state.info_licence &&
        <EurestoDiv id={'onglet_contact_licence_active'} title='Licences Euresto' expandable expanded>
          <Datagrid filterable={false}
            isSubComponent={true}
            data={this.state.info_licence}
            style={{
              maxHeight: 400
            }}
            columnsName={[
              {
                Header: 'id',
                accessor: 'id',
                id: 'id',
                show: false
              }, {
                Header: 'Dossier',
                id: 'dossier',
                accessor: 'dossier',
                Cell: row => <span style={{
                  textAlign: 'left',
                  width: '100%'
                }}>{row.original.dossier}</span>
              }, {
                Header: 'Version',
                id: 'version',
                accessor: 'version',
                Cell: row => <span style={{
                  textAlign: 'left',
                  width: '100%'
                }}>{row.original.version}</span>
              }, {
                Header: 'Repertoire',
                id: 'repertoire',
                accessor: 'repertoire',
                Cell: row => <span style={{
                  textAlign: 'left',
                  width: '100%'
                }}>{row.original.repertoire}</span>
              }, {
                Header: '32bits',
                id: '32bits',
                accessor: '32bits',
                Cell: row => <span style={{
                  textAlign: 'left',
                  width: '100%'
                }}>{row.original['32bits']}</span>
              }, {
                Header: 'ip',
                id: 'ip',
                accessor: 'ip',
                Cell: row => <span style={{
                  textAlign: 'left',
                  width: '100%'
                }}>{row.original.ip}</span>
              }, {
                Header: 'Date Version',
                id: 'date_version',
                accessor: 'date_version',
                Cell: row => row.original.date_version && <span style={{ textAlign: 'left', width: '100%' }}>{moment(row.original.date_version).format('DD/MM/YY HH:mm')}</span> || ''

              }, {
                Header: 'Date Patch',
                id: 'date_version',
                accessor: 'date_version',
                Cell: row => row.original.date_patch && <span style={{ textAlign: 'left', width: '100%' }}>{moment(row.original.date_patch).format('DD/MM/YY HH:mm')}</span> || ''

              }, {
                Header: 'Version Hyperfile',
                id: 'pcsoft_version_hyperfile',
                accessor: 'pcsoft_version_hyperfile',
                Cell: row => row.original.pcsoft_version_hyperfile && <span style={{ textAlign: 'left', width: '100%' }}>{row.original.pcsoft_version_hyperfile}</span> || ''

              }, {
                Header: 'Date dernière demande',
                id: 'date_creation',
                accessor: 'date_creation',
                Cell: row => <span style={{
                  textAlign: 'left',
                  width: '100%'
                }}>{moment(row.original.date_creation).format('DD[/]MM[/]YY LT')}</span>
              },
            ]}
            type='client' />
        </EurestoDiv>
      }
      {

        this.state.contact.action === 'update' && this.state.typeContact === Constants.access.ETABLISSEMENT && this.state.info_postes &&
        <EurestoDiv id={'onglet_contact_postes'} title='Postes' expandable expanded>
          <Datagrid filterable={false}
            style={{
              maxHeight: 400
            }}
            isSubComponent={true}
            data={this.state.info_postes}
            columnsName={[
              {
                Header: 'id',
                accessor: 'id',
                id: 'id',
                show: false
              }, {
                Header: 'Nom',
                id: 'libelle',
                accessor: 'libelle',
                Cell: row => <span style={{ textAlign: 'left', width: '100%' }}>{row.original.libelle}</span>
              }, {
                Header: 'Version',
                id: 'version',
                accessor: 'version',
                Cell: row => <span style={{ textAlign: 'left', width: '100%' }}>{row.original.version}</span>
              }, {
                Header: 'Répertoire',
                id: 'repertoire',
                accessor: 'repertoire',
                Cell: row => <span style={{ textAlign: 'left', width: '100%' }}>{row.original.repertoire}</span>
              }, {
                Header: '32Bits',
                id: 'repertoire',
                accessor: 'repertoire',
                Cell: row => <span style={{ textAlign: 'left', width: '100%' }}>{row.original.repertoire}</span>
              }, {
                Header: 'ip',
                id: 'ip',
                accessor: 'ip',
                Cell: row => <span style={{ textAlign: 'left', width: '100%' }}>{row.original.ip}</span>

              }, {
                Header: 'Version protection',
                id: 'protection_version',
                accessor: 'protection_version',
                Cell: row => <span
                  style={{ textAlign: 'left', width: '100%' }}>{row.original.protection_version}</span>
              }, {
                Header: 'Date dernière demande',
                id: 'date_creation',
                accessor: 'date_creation',
                Cell: row => row.original.date_creation && <span style={{
                  textAlign: 'left',
                  width: '100%'
                }}>{moment(row.original.date_creation).format('DD[/]MM[/]YY LT')}</span> || ''
              },
            ]}
            type='client' />
        </EurestoDiv>
      }
    </div>)
  }

  handleContactInformationsTiersChange = (data, name) => {
    this.setState({
      contact: {
        ...this.state.contact,
        information_tiers: {
          ...this.state.contact.information_tiers,
          [name]: data
        }
      }
    })
  }

  onChangeRelationsClientEtablissementsGroupe = (data, type) => {
    this.setState({
      contact: {
        ...this.state.contact,
        etablissements: data
      }
    }, this.forceUpdate)
  }

  onChangeEtablissementsGroupe = (data) => {
    const { etablissements } = this.state.contact

    const pos = etablissements.indexOf(data)
    if (pos === -1) {
      etablissements.push(data)
    } else {
      etablissements.splice(pos, 1)
    }
    this.setState({
      contact: {
        ...this.state.contact,
        etablissements: etablissements
      },
    })
  }

  TabDossier = _ => {
    return <Sdd preSelectedClasseur={this.state.preSelectedClasseur}
      preSelectedDossier={this.state.preSelectedDossier}
      preSelectedAction={this.state.preSelectedAction}
      showMessageManagement={false}
      contact_email={this.state.contact.email}
      contact_portable={this.state.contact.portable}
      client_id={this.state.contact.id}
      dossier_status={this.props.dossier_status}
      handleDossier={this.handleNewDossier} />
  }

  handleNewDossier = (id, json) => {
    if (json.contact_id !== this.state.contact.id) {
      browserHistory.push({
        pathname: '/crm/' + json.contact_id,
        state: {
          dossier_id: id,
          classeur_id: json.classeur_id,
          UserTabSelected: 2,
          dossier_status: json.status
        }
      })
    }
  }

  changeGridViewFinancier = () => {
    this.setState({
      showFinanceGrid: !this.state.showFinanceGrid,
      showFinanceGridKey: Utils.getRandomNumber()
    })
  }

  onCloseFichierModal = () => {
    this.setState({
      fichierModalOpen: false,
      modalKeyFichier: Utils.getRandomNumber(),
      viewFichier: false
    }, () => this.forceUpdate())
  }
  viewFichier = (row) => {
    const dataFichier = this.state.fichiers.find(d => (d.id === row.id))
    this.setState({
      viewFichier: true,
      fichierModalOpen: true,
      modalKeyFichier: Utils.getRandomNumber(),
      key_fichier: Utils.getRandomNumber(),
      typeFichier: 1,
      decodeFichier: dataFichier
    })
  }

  changeShowFichier = () => {
    this.setState({
      showFichierGrid: !this.state.showFichierGrid,
      showFichierGridKey: Utils.getRandomNumber()
    })
  }

  TabFichier = () => {
    // let viewFichier
    // if (this.state.showFichierGrid === true) {
    //   viewFichier = this.DataGridFichier()
    // } else {
    //   viewFichier = this.DataUploadFichier()
    // }

    console.log(this.state.contactToken)

    return this.state.contactToken && <Media raz unsave config={{token: this.state.contactToken}} showAsEntity showSearch defaultSearch={{'[[options]]': {token: this.state.contactToken}}}/>
  }

  DataUploadFichier = () => <ViewUpload handleUpload={() => {
  }} contact_id={this.props.data.id} codeEuresto={this.state.contact.code || ''} />

  DataGridFichier = () => {
    const columnsFichier = [
      {
        Header: 'id',
        accessor: 'id',
        id: 'id',
        show: false
      },

      {
        Header: <i className={'fa fa-clock-o'} />,
        accessor: 'date_creation',
        filterable: false,
        id: 'date_creation',
        Cell: (row) => row.original.date_creation &&
          <span>{moment(row.original.date_creation, 'YYYY-MM-DD').format('DD/MM/YY')}</span> || ''
      }, {
        Header: 'Fichiers',
        id: 'libelle',
        accessor: 'libelle',
        Cell: row => <span style={{ textAlign: 'left', width: '100%' }}>{row.original.libelle}</span>
      }, {
        Header: '',
        width: 25,
        filterable: false,
        Cell: (row) => {
          return <a onClick={(e) => {
            e.stopPropagation()
          }} className={'fa fa-download'} href={row.original.lien} target={'_blank'} download='download' />
        }
      }, {
        Header: '',
        width: 25,
        filterable: false,
        Cell: (row) => {
          return <i onClick={this.deleteFile(row.original.id)} className={'cursor-pointer ei-commun_supprimer'} />
        }
      }
    ]
    return <Datagrid filterable={false} data={this.state.fichiers || []} columnsName={columnsFichier}
      onClick={this.viewFichier}
      type='client' />
  }

  deleteFile = (id) => e => {
    e.stopPropagation()
    ApiRequest(project.api + 'upload', {
      action: 'delete',
      requete: 'upload',
      id: id
    })
  }

  TabFacture = () => {
    return (<EurestoDiv title={<Grid container><Fab
      size="small"
      style={{ zIndex: 2 }}
      onClick={
        this.changeGridViewFinancier
      }
      className={
        ('EurestoPrimary')
      }> &nbsp;
      <i className={'fa fa-' + (
        this.state.showFinanceGrid && 'th-list' || 'line-chart') + ' EurestoSecondary--text'} /> &nbsp;
      <span className={'EurestoText--text'} /></Fab> &nbsp;
      Financier</Grid>}>
      <Financiers view={this.state.showFinanceGrid}
        client_id={this.state.contact.id} />
    </EurestoDiv>)
  }

  onSaveOptions = (options) => {
    this.setState({
      options: options,
      action_option: 'view'
    })
  }

  onSaveLangues = (langues) => {
    this.setState({
      langues: langues
    })
  }

  TabOptions = _ => {
    return <Options langues={this.state.langues} options={this.state.options}
      onSaveOptions={this.onSaveOptions}
      key={this.state.action_option}
      action_option={this.state.action_option}
      onSaveLangues={this.onSaveLangues}
      contact_id={this.state.contact && this.state.contact.id} />
  }

  TabReservations = _ => <Reservations
    style={{
      height: 'calc(100% - 100px)',
      maxHeight: 'calc(100% - 100px)'
    }}
    paperProps={{
      style: { height: 'calc(100% - 100px)' }
    }}
    searchProps={{
      mainStyle: { display: 'none' },
      style: { top: -28 }
    }}
    //withUser={false}
    showSearch={true}
    name={'historique_contact' + this.state.contact.id}
    defaultSearch={{ contact_id: this.state.contact.id }}
    hideForm />

  onChangeArchive = isArchive => {
    this.setState({
      archive: isArchive,
      ...(!isArchive && {
        contact: {
          ...this.state.contact,
          arhive_id: undefined,
          archive_commentaire: '',
          motif_id: undefined
        }
      } || {})
    })
  }

  TabDivers = _ => <Divers onChangeArchive={this.onChangeArchive}
    isConnectedToSellsy={this.state.contact.sellsy_id}
    key_contact={this.state.contact.key_contact}
    archive_id={this.state.contact.archive_id}
    motif_id={this.state.contact.motif_id}
    id={this.state.contact.id}
    commentaire={this.state.contact.archive_commentaire}
    onChange={this.handleContactStateChange} />


  TabActivite = _ => <iframe style={{ width: '100%', height: 'calc(100% - 5px)', maxHeight: 'calc(100% - 5px)' }}
    frameBorder={"0"}
    src={`${project.api.replace(':5000', ':8002').replace('api', 'cloud')}crm/${this.state.contact.id}/activites?navigation=off&token=${sessionStorage.getItem('token')}`} sandbox />

  TabHeberge = _ => <iframe style={{ width: '100%', height: '100%', maxHeight: '100%' }}
    frameBorder={"0"}
    src={`${project.api.replace(':5000', ':8002').replace('api', 'cloud')}crm/${this.state.contact.id}/serveur-heberge?navigation=off&token=${sessionStorage.getItem('token')}`} sandbox />
}



// WEBPACK FOOTER //
// ./app/App/Module/CRM/Component/Fiche/FicheContact.js